import React, { useState, useContext, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { NameContext } from "../context/NameContext";
import MonoButton from "./MonoButton";

import { useNavigate } from "react-router-dom";
import RoughBorder from "../kits/LayoutKit/RoughBorder";

const ChangeNameModal = ({ onClose }) => {
  const {name,  setName } = useContext(NameContext);
  const navigate = useNavigate(); // 
  const [value, setValue] = useState("");
  const nameRef = useRef(null); 

  useEffect(() => {
    if(!name) {
        // Optional Her Feedback oder UI Reeset 
        navigate("/"); // Startscreen
    }
  }, [name]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) {
      setName(value.trim());
      onClose(); // Modal schließen
    }
  };

  return createPortal(
  
    <div className="fixed inset-0 bg-black/40 backdrop-blur-lg z-[200] flex items-center justify-center">
      <div className="p-6 rounded-md w-full max-w-sm  bg-white text-center font-mono shadow-lg relative">
       
        <h2 className="text-sm mb-4 font-mono">Wie darf ich dich nennen?</h2>

        <form onSubmit={handleSubmit}>
     <input
  type="text"
  placeholder={name ? `Derzeitiger Name ${name}` : "Wie darf ich dich nennen?"}
  value={value}
  onChange={(e) => setValue(e.target.value)}
  className="w-full p-2 border border-gray-300 rounded-md mb-4 text-xs font-mono text-center focus:outline-none focus:ring-1 focus:ring-gray-800"
  autoFocus
/>
          <MonoButton className="w-full text-xs" type="submit">
            Speichern
          </MonoButton>
       <button
    type="button"
    onClick={onClose}
    className="w-full text-xs mt-2 text-gray-700 hover:text-orange-300 underline"
  >
    Abbrechen
  </button>
        </form>
    
      </div>
                 <RoughBorder
          parentRef={nameRef}
          radius={10}
          padding={3}
      color="#AC8E66" 
          strokeWidth={0.3}
          roughness={1}
          bowing={2}
        />
    </div>,
    document.body
  );
};

export default ChangeNameModal;
